"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Look for a cleaner solution.
var requestsVm = void 0;

var JobRequestsController = function () {
  function JobRequestsController(JobRequestsService, FilterService, AuthService, UsersService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, JobRequestsController);
    this.usersService = UsersService;
    this.jobRequestsService = JobRequestsService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.jobRequestsDataSource = this.jobRequestsService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this));
    this.gridOptions = this.getGridOptions();
    requestsVm = this;
  }

  (0, _createClass3.default)(JobRequestsController, [{
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.jobRequestsDataSource,
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          // template: "No match found. Change your filter criteria."
          template: "None yet."
        },
        columns: [{
          field: "requestDate", title: "Request Date", filterable: false, width: "4rem",
          template: "<span>#= kendo.toString(new Date(requestDate), 'dd-MM-yyyy') #</span>"
        }, {
          field: "ownerFullName", title: "Job Owner", filterable: false, sortable: false, width: "6rem",
          template: "<a class=\"cell\" href=\"#= '/users/' + ownerUserId #\">#= ownerFullName #</a>"
        }, { field: "jobType", title: "Job Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getJobTypeText(dataItem.jobType);
          } }, { field: "id", title: "Request #", filterable: false, sortable: false, width: "2rem", template: function template(dataItem) {
            return "#" + dataItem.id;
          } }, {
          field: "scheduledCallLocalTime", title: "Briefing Call", filterable: false, width: "4rem",
          template: function template(dataItem) {
            return _this._getScheduledDate(dataItem);
          }
        }, { field: "jobRequestStatus", title: "Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getJobRequestStatusText(dataItem.jobRequestStatus);
          } },
        // {
        //   field: "state", title: "State", filterable: false, width: "4rem",
        //   template: `<span>#= (country === 'au' ? state.toUpperCase() : state) #</span>`,
        // },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
        // { title: 'Post Job', command: { text: "Post Job", click: this.handlePostJob }, width: "4rem" },
        { title: 'Transfer Job', command: { text: "Transfer Job", click: this.handleTransferJob }, width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }

    // https://demos.telerik.com/kendo-ui/grid/custom-command

  }, {
    key: "handleTransferJob",
    value: function handleTransferJob(e) {
      e.preventDefault();

      var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

      if (dataItem.jobRequestStatus != _constants2.default.jobRequestStatus.JOB_POSTED) {
        alert('Job can only be transfered after it has been posted. ');
        return;
      }

      if (confirm('Are you sure that you would like to finalise this job and transfer it to the parent? This action is irreversible.')) {
        requestsVm.jobRequestsService.transferJob(dataItem, function () {
          requestsVm.jobRequestsDataSource.read();
        });
      } else {
        console.log('no-transfer');
      }
    }
  }, {
    key: "handlePostJob",
    value: function handlePostJob(e) {
      e.preventDefault();

      var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

      if (dataItem.jobRequestStatus != _constants2.default.jobRequestStatus.CALL_SCHEDULED) {
        alert('Only requests in a scheduled call status can be posted. ');
        return;
      }
      var jobManagerId = dataItem.jobManagerId;

      requestsVm.loginAsUser(2, jobManagerId);
    }
  }, {
    key: "loginAsUser",
    value: function loginAsUser(targetDevice, userId) {
      var _this2 = this;

      this.usersService.getLoginAsUserAccessToken(userId, function (response) {
        console.log("Access token::", response.data);
        _this2.redirectToTarget(targetDevice, response.data.accessToken, 'au');
      }, function (error) {});
    }
  }, {
    key: "redirectToTarget",
    value: function redirectToTarget(targetDevice, token, country) {
      var rootUrl = _env2.default.getLoginAsBaseUrl(targetDevice, country);
      var url = rootUrl + ("?admin_mode=1&access_token=" + token);
      console.log(url);
      window.open(rootUrl + ("?admin_mode=1&access_token=" + token));
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.jobsMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this3 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this3.applyFilters();
        }).catch(function (error) {
          _this3.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getScheduledDate",
    value: function _getScheduledDate(dataItem) {
      if (!dataItem.scheduledCallLocalTime) return 'N/A';

      return kendo.toString(new Date(dataItem.scheduledCallLocalTime), 'dd/MM @ hh:mmtt');
    }
  }, {
    key: "_getJobRequestActions",
    value: function _getJobRequestActions(dataItem) {
      // <span class='k-icon k-i-edit'></span>
      // const postJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Post Job</a>";
      var transferJobAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Transfer Job</a>";
      var notesAction = "<a role='button' class='k-button k-button-icontext k-grid-edit' href='##'>Notes</a>";

      return "<span>" + transferJobAction + notesAction + "</span>";
    }
  }, {
    key: "_getHelperStats",
    value: function _getHelperStats(dataItem) {
      return dataItem.activeInvites + " / " + dataItem.totalInvites;
    }
  }, {
    key: "_getOpenRate",
    value: function _getOpenRate(dataItem) {
      var activity = dataItem.activeInvites + " / " + dataItem.totalInvites;
      var openRate = dataItem.activeInvites / dataItem.totalInvites;
      return kendo.format('{0:p0}', openRate);
    }
  }, {
    key: "_getJobTypeText",
    value: function _getJobTypeText(type) {
      switch (type) {
        case _constants2.default.jobType.BABYSITTING:
          return "Babysitting";
        case _constants2.default.jobType.NANNYING:
          return "Nannying";
        case _constants2.default.jobType.AFTER_SCHOOL_CARE:
          return "After School Care";
        case _constants2.default.jobType.BEFORE_SCHOOL_CARE:
          return "Before School Care";
        case _constants2.default.jobType.BEFORE_AFTER_SCHOOL_CARE:
          return "Before/After School Care";
        case _constants2.default.jobType.AU_PAIR:
          return "Au Pair";
        case _constants2.default.jobType.PRIMARY_SCHOOL_TUTORING:
          return "Primary School Tutoring";
        case _constants2.default.jobType.HIGH_SCHOOL_TUTORING:
          return "High School Tutoring";
        case _constants2.default.jobType.ONE_OFF_ODD_JOBS:
          return "Odd Job";
      }
    }
  }, {
    key: "_getJobRequestStatusText",
    value: function _getJobRequestStatusText(status) {
      switch (status) {
        case _constants2.default.jobRequestStatus.NEW_REQUEST:
          return "New Request";
        case _constants2.default.jobRequestStatus.CALL_SCHEDULED:
          return "Call Scheduled";
        case _constants2.default.jobRequestStatus.JOB_POSTED:
          return "Job Posted";
        case _constants2.default.jobRequestStatus.JOB_TRANSFERRED:
          return "Job Transferred";
        case _constants2.default.jobRequestStatus.JOB_AWARDED:
          return "Job Awarded";
      }
    }
  }, {
    key: "_getManagedByText",
    value: function _getManagedByText(status) {
      switch (status) {
        case _constants2.default.managedBy.USER:
          return "DIY";
        case _constants2.default.managedBy.SYSTEM:
          return "Assist";
      }

      return "";
    }
  }]);
  return JobRequestsController;
}();

exports.default = JobRequestsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-requests/job-requests.controller.js
 **/